var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 4.5H15.75C16.575 4.5 17.25 5.175 17.25 6V12C17.25 12.825 16.575 13.5 15.75 13.5H2.25C1.425 13.5 0.75 12.825 0.75 12V6C0.75 5.175 1.425 4.5 2.25 4.5ZM2.25 12H15.75V6H14.25V9H12.75V6H11.25V9H9.75V6H8.25V9H6.75V6H5.25V9H3.75V6H2.25V12Z",
    fill: "#A3A9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasure);
export default __webpack_public_path__ + "static/media/measure.7875e562a03eafb1bd49855baf773eef.svg";
export { ForwardRef as ReactComponent };